import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, Home, BookOpen, Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center font-plex selection:bg-[#00FF88]/20 selection:text-white p-6 relative overflow-hidden">
      <Helmet>
        <title>404 Not Found | Jamadhan</title>
        <meta name="description" content="The page you are looking for does not exist or has been moved." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* GLOWS */}
      <div className="absolute top-[10%] left-1/4 w-[500px] h-[500px] bg-[#00F0FF]/10 rounded-full blur-[150px] pointer-events-none z-0" />
      
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <h1 className="text-[120px] md:text-[180px] font-black font-outfit text-white/5 leading-none select-none drop-shadow-2xl">
          404
        </h1>
        <div className="-mt-16 md:-mt-24 mb-8">
          <h2 className="text-3xl md:text-5xl font-bold text-white font-outfit mb-4">
            Page Not Found
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-md mx-auto">
            We couldn't find the page you're looking for. It might have been moved, deleted, or the URL might be misspelled.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
          <Link to="/" className="group flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#00F0FF]/50 rounded-xl p-4 transition-all duration-300">
            <Home className="w-5 h-5 text-[#00F0FF] group-hover:scale-110 transition-transform" />
            <span className="text-white font-medium">Back to Home</span>
          </Link>
          <Link to="/courses" className="group flex items-center justify-center gap-2 bg-[#00FF88]/10 hover:bg-[#00FF88]/20 border border-[#00FF88]/20 hover:border-[#00FF88]/50 rounded-xl p-4 transition-all duration-300">
            <BookOpen className="w-5 h-5 text-[#00FF88] group-hover:scale-110 transition-transform" />
            <span className="text-white font-medium">View Courses</span>
          </Link>
        </div>
      </div>
      
      {/* BACKGROUND GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none opacity-50 z-0" />
    </div>
  );
}
